import { ISelectVehiclesHook } from '@models';
import { useStore } from '@stores';
import { debounce } from 'lodash';
import { useEffect, useState } from 'react';

export const useSelectVehicles = (): ISelectVehiclesHook => {
  const { vehicleStore } = useStore();
  const { selectVehicles, selectLoading, selectSkipCount, selectPageSize } = vehicleStore;
  const [registrationNumber, setRegistrationNumber] = useState<string>();

  useEffect(() => {
    registrationNumber &&
      vehicleStore.getSelectVehicles({
        registrationNumber,
        maxResultCount: selectPageSize,
        skipCount: selectSkipCount,
      });

    return () => vehicleStore.clearSelectVehicles();
  }, [vehicleStore, registrationNumber, , selectSkipCount, selectPageSize]);

  const handleSearch = debounce((text: string | undefined) => {
    setRegistrationNumber(text);
  }, 500);

  return {
    vehicles: Array.from(selectVehicles.values()),
    loading: selectLoading,
    handleSearch,
  };
};
